export enum ToastLevel {
  info,
  error,
  serverError,
  validationError,
}

export type ToastContent = {
  message: string;
  level?: ToastLevel;
  title?: string;
  error_code?: string;
  additional_info?: string;
  displayTime?: number;
};

export type Toast = {
  toast_id: string;
  content: ToastContent;
};
